import { useStoreState } from '../../../store';
import { isNavbarHidden } from './useAppHeaderNav';

export function useShowInlineActions(): boolean {
  const navbar = useStoreState(state => state.orgContext.navbar);
  return isNavbarHidden(navbar);
}
